import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';
import { RelativeTimePipe } from '@context/frontend/common';
import { AlgoliaContentThumbnailComponent } from '@context/frontend/content';
import { AlgoliaContent } from '@context/shared/types/search';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIcon } from '@taiga-ui/core';

@Component({
	imports: [
		AlgoliaContentThumbnailComponent,
		TranslocoModule,
		RelativeTimePipe,
		TuiIcon,
	],
	selector: 'ctx-global-search-folder',
	templateUrl: 'global-search-folder.component.html',
	styleUrl: 'global-search-folder.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalSearchFolderComponent {
	readonly folder = input.required<AlgoliaContent>();

	readonly updatedAt = computed(() => new Date(this.folder().updatedAt));
}
